import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';

const { METHOD: { POST } } = HOOKS_SETTINGS;
const { CONTROLLERS: { MOVE_FROM_TAX_BUCKET: { BASE, VERSION } } } = USER;

export const useMoveFromTaxBucketQuery = ({
  customerId, pullFromTaxBucket, amount, onSuccess,
}: {customerId: string, pullFromTaxBucket: boolean, amount:number, onSuccess?: ()=>void }) => useQuery(
  ['moveFromTaxBucket'],
  async () => {
    if (!customerId || !amount) {
      return '';
    }
    const { data } = await httpService({
      url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`,
      method: POST,
      data: {
        amount,
        pullFromTaxBucket,
      },
    });
    return data;
  },
  {
    enabled: false,
    onSuccess: () => { if (onSuccess) onSuccess(); },
  },
);
